module.exports = "/assets/data/ec0ca9bf5ba0f1fc46f2b23726d69ca3-NW7.data.json";